import { render, staticRenderFns } from "./NotificacaoEditar.vue?vue&type=template&id=274f9866"
import script from "./NotificacaoEditar.vue?vue&type=script&lang=js"
export * from "./NotificacaoEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports